export const TabletOrMobileScreenQuery = '(max-width: 991px)';
export const MobileScreenQuery = '(max-width: 767px)';

export const DesktopScreenQuery = '(max-width: 1199px)';
